import {IFormInput} from '../../initialValue';
import {IOptionGroup} from '../../../../../../../common-code/interfaces/option/IOptionGroup';
import {IOption} from '../../../../../../../common-code/interfaces/option/IOption';
import {CommonHelper} from 'common-code';

export function getFacades(date: IFormInput): IOptionGroup | IOption | undefined | null {
    const {facades} = date;
    return CommonHelper.deepCopy(facades);
}